export interface RuntimeConfig {
  apiBaseUrl: string;
  environment: string;
  appVersion: string;
}

let _config: RuntimeConfig | null = null;

const FALLBACK: RuntimeConfig = {
  apiBaseUrl: "/api/v1",
  environment: "development",
  appVersion: "dev",
};

export async function loadConfig(): Promise<RuntimeConfig> {
  if (_config) return _config;
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const body = (await res.json()) as Partial<RuntimeConfig>;
    _config = { ...FALLBACK, ...body } as RuntimeConfig;
  } catch {
    _config = FALLBACK;
  }
  return _config;
}

export function getConfig(): RuntimeConfig {
  if (!_config) throw new Error("Runtime config not loaded yet");
  return _config;
}
